import React from 'react';
import { BugIcon, NetIcon, ScissorsIcon, TransferIcon, HarvestIcon, GearIcon, DiamondIcon, WarningIcon } from '../components/icons/Icons';

export const SYMBOL_ITEMS = [
  { key: 'ipm',           glyph: <BugIcon width="16" height="16" />,      label: 'IPM Active' },
  { key: 'net',           glyph: <NetIcon width="16" height="16" />,      label: 'Net' },
  { key: 'defoliation',   glyph: <ScissorsIcon width="16" height="16" />, label: 'Defoliation' },
  { key: 'transfer',      glyph: <TransferIcon width="16" height="16" />, label: 'Transfer' },
  { key: 'harvest_ready', glyph: <HarvestIcon width="16" height="16" />,  label: 'Harvest Ready' },
  { key: 'mode_change',   glyph: <GearIcon width="16" height="16" />,     label: 'Mode Change' },
  { key: 'supply_ready',  glyph: <DiamondIcon width="16" height="16" />,  label: 'Supply Ready' },
  { key: 'issue',         glyph: <WarningIcon width="16" height="16" />,  label: 'Open Issue' },
]

export const STATUS_ITEMS = [
  { color: '#4ade80', label: 'Normal' },
  { color: '#facc15', label: 'IPM / Cultivation Issue' },
  { color: '#f87171', label: 'Control / Env Alert' },
  { color: '#4a4a68', label: 'Idle / Offline' },
]
